module.exports = __webpack_public_path__ + "media/images/Branding/HW Red 3-a39c4b1b10a69a48b9eec62b89896642.png";